import { TicketIcon } from "@heroicons/react/24/outline";
import { lazy } from "react";

import type { FeatureMetadata } from "../../feature.types";
import { buildCrudPermissions, permissionId } from "../../shared/featureFactories";

export const FeeTypesFeature: FeatureMetadata = {
  id: "fee-types",
  moduleName: "feesFinance",
  navigation: {
    label: "Fee Types",
    path: "/fee-types",
    icon: TicketIcon,
    order: 3,
  },
  route: {
    path: "/fee-types",
    element: lazy(() => import("./pages/AdminFeeTypes")),
  },
  permissions: buildCrudPermissions("FeeFinance", "FeeType", {
    view: permissionId("FeeFinance", "FeeType", "view"),
    create: permissionId("FeeFinance", "FeeType", "manage"),
    edit: permissionId("FeeFinance", "FeeType", "manage"),
    delete: permissionId("FeeFinance", "FeeType", "manage"),
  }),
  readiness: "live",
};
